import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { BookOpenIcon, UsersIcon, TrophyIcon, ClockIcon, TargetIcon, TrendingUpIcon, AwardIcon, ArrowRightIcon, ShieldCheckIcon, RocketIcon, HeadphonesIcon, SparklesIcon, CheckCircleIcon, StarIcon, BarChart3Icon, ZapIcon, LockIcon, DollarSignIcon, BriefcaseIcon, GraduationCapIcon } from 'lucide-react';
export function About() {
  const features = [{
    icon: BookOpenIcon,
    title: 'Training Complet',
    description: 'Masterclass profesionale cu 10 cursuri structurate pas cu pas',
    color: 'from-[#357BEB] to-[#2868d8]'
  }, {
    icon: ClockIcon,
    title: 'Suport 24/7',
    description: 'Asistență individuală 1-la-1 disponibilă oricând',
    color: 'from-[#21A366] to-[#1a8555]'
  }, {
    icon: UsersIcon,
    title: 'Comunitate Activă',
    description: 'Peste 50+ agenți activi în ecosistemul CLC',
    color: 'from-[#FF6B35] to-[#e55a2b]'
  }, {
    icon: TrophyIcon,
    title: 'Rezultate Dovedite',
    description: '1000+ tranzacții finalizate cu succes',
    color: 'from-purple-500 to-purple-600'
  }];
  const values = [{
    icon: TargetIcon,
    title: 'Performanță bazată pe merit',
    description: 'Sistemul nostru recompensează rezultatele reale, nu vechimea. Fiecare agent avansează prin performanță măsurabilă și transparentă.',
    color: 'from-[#357BEB] to-[#2868d8]'
  }, {
    icon: TrendingUpIcon,
    title: 'Dezvoltare continuă',
    description: 'Investim constant în training-uri actualizate, proceduri optimizate și suport individual pentru fiecare membru al echipei.',
    color: 'from-[#21A366] to-[#1a8555]'
  }, {
    icon: AwardIcon,
    title: 'Transparență totală',
    description: 'Comisioane clare, procese documentate și comunicare deschisă. Știi întotdeauna unde te afli și ce urmează în cariera ta.',
    color: 'from-[#FF6B35] to-[#e55a2b]'
  }];
  const stats = [{
    number: '7',
    label: 'Ani de experiență',
    suffix: '+',
    icon: TrophyIcon,
    color: 'from-blue-500 to-indigo-600'
  }, {
    number: '1000',
    label: 'Tranzacții finalizate',
    suffix: '+',
    icon: CheckCircleIcon,
    color: 'from-emerald-500 to-green-600'
  }, {
    number: '10',
    label: 'Cursuri de training',
    suffix: '',
    icon: BookOpenIcon,
    color: 'from-purple-500 to-pink-600'
  }, {
    number: '24/7',
    label: 'Suport disponibil',
    suffix: '',
    icon: HeadphonesIcon,
    color: 'from-orange-500 to-red-600'
  }];
  const benefits = [{
    icon: RocketIcon,
    title: 'Start rapid în carieră',
    description: 'Primele tranzacții în 30-60 de zile cu sistemul nostru structurat',
    color: 'from-[#357BEB] to-[#2868d8]'
  }, {
    icon: ShieldCheckIcon,
    title: 'Suport juridic complet',
    description: 'Echipă juridică dedicată pentru toate contractele și tranzacțiile',
    color: 'from-[#21A366] to-[#1a8555]'
  }, {
    icon: BarChart3Icon,
    title: 'Platformă digitală avansată',
    description: 'CRM propriu, AI tools și automatizări pentru eficiență maximă',
    color: 'from-purple-500 to-purple-600'
  }, {
    icon: DollarSignIcon,
    title: 'Comisioane competitive',
    description: 'Sistem transparent de comisionare cu bonusuri de performanță',
    color: 'from-emerald-500 to-green-600'
  }, {
    icon: UsersIcon,
    title: 'Leaduri garantate',
    description: 'Liste zilnice cu proprietari și clienți verificați',
    color: 'from-orange-500 to-red-600'
  }, {
    icon: GraduationCapIcon,
    title: 'Mentorat personalizat',
    description: 'Ghidare individuală de la agenți seniori cu experiență dovedită',
    color: 'from-cyan-500 to-blue-600'
  }];
  return <div className="w-full min-h-screen bg-white" data-id="element-7106">
      {/* Hero Section - MOBILE OPTIMIZED */}
      <div className="relative bg-gradient-to-br from-[#132C53] to-[#1e4278] text-white overflow-hidden" data-id="element-7107">
        {/* Background patterns */}
        <div className="absolute inset-0 opacity-10" data-id="element-7108">
          <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMSIvPjwvcGF0dGVybj48L2RlZnM+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0idXJsKCNncmlkKSIvPjwvc3ZnPg==')] bg-repeat" data-id="element-7109"></div>
        </div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20 md:py-24 lg:py-32" data-id="element-7110">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center" data-id="element-7111">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            duration: 0.6
          }} className="text-left" data-id="element-7112">
              {/* Badge - MOBILE OPTIMIZED */}
              <motion.div initial={{
              opacity: 0,
              scale: 0.9
            }} animate={{
              opacity: 1,
              scale: 1
            }} transition={{
              duration: 0.5,
              delay: 0.2
            }} className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-3 py-1.5 sm:px-4 sm:py-2 rounded-full mb-4 sm:mb-6 border border-white/20" data-id="element-7113">
                <StarIcon className="w-3 h-3 sm:w-4 sm:h-4 text-yellow-400 fill-current" data-id="element-7114" />
                <span className="text-xs sm:text-sm font-medium text-white" data-id="element-7115">
                  Ecosistemul complet pentru agenți imobiliari
                </span>
              </motion.div>

              <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-4 sm:mb-6 leading-tight" data-id="element-7116">
                Despre Ecosistemul <br data-id="element-7117" />
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#357BEB] to-[#21A366]" data-id="element-7118">
                  Cautlocuință.ro
                </span>
              </h1>

              <p className="text-base sm:text-lg md:text-xl text-gray-300 mb-6 sm:mb-8 max-w-lg leading-relaxed" data-id="element-7119">
                Un sistem complet de training, suport și dezvoltare profesională
                care transformă agenți începători în consultanți imobiliari de
                top.
              </p>

              <motion.div initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.6,
              delay: 0.4
            }} data-id="element-7120">
                <Link to="/auth/register" className="inline-flex items-center justify-center px-6 py-3 sm:px-8 sm:py-4 text-base sm:text-lg font-bold rounded-xl sm:rounded-2xl text-white bg-gradient-to-r from-[#357BEB] to-[#21A366] hover:shadow-lg hover:scale-105 transition-all duration-300 group w-full sm:w-auto" data-id="element-7121">
                  Devino Agent Acum
                  <ArrowRightIcon className="ml-2 w-4 h-4 sm:w-5 sm:h-5 group-hover:translate-x-1 transition-transform" data-id="element-7122" />
                </Link>
              </motion.div>
            </motion.div>

            {/* Right Visual - Stats Cards - MOBILE OPTIMIZED */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} className="relative" data-id="element-7123">
              <div className="relative z-10 bg-white/5 backdrop-blur-md rounded-2xl sm:rounded-3xl p-6 sm:p-8 border border-white/10 shadow-2xl" data-id="element-7124">
                <div className="grid grid-cols-2 gap-3 sm:gap-4" data-id="element-7125">
                  {[{
                  value: '7+',
                  label: 'Ani experiență'
                }, {
                  value: '1000+',
                  label: 'Tranzacții'
                }, {
                  value: '50+',
                  label: 'Agenți activi'
                }, {
                  value: '24/7',
                  label: 'Suport'
                }].map((stat, idx) => <motion.div key={idx} className="bg-white/5 rounded-xl sm:rounded-2xl p-3 sm:p-4 border border-white/5" data-id="element-7126">
                      <div className="text-2xl sm:text-3xl font-bold text-white mb-1" data-id="element-7127">
                        {stat.value}
                      </div>
                      <div className="text-xs sm:text-sm text-gray-300" data-id="element-7128">
                        {stat.label}
                      </div>
                    </motion.div>)}
                </div>

                <div className="mt-6 sm:mt-8 pt-4 sm:pt-6 border-t border-white/10" data-id="element-7129">
                  <div className="flex items-center space-x-2 text-xs sm:text-sm text-gray-300" data-id="element-7130">
                    <CheckCircleIcon className="w-3 h-3 sm:w-4 sm:h-4 text-green-400" data-id="element-7131" />
                    <span data-id="element-7132">Sistem complet digitalizat</span>
                  </div>
                  <div className="flex items-center space-x-2 text-xs sm:text-sm text-gray-300 mt-2" data-id="element-7133">
                    <CheckCircleIcon className="w-3 h-3 sm:w-4 sm:h-4 text-green-400" data-id="element-7134" />
                    <span data-id="element-7135">Suport dedicat 24/7</span>
                  </div>
                </div>
              </div>

              {/* Decorative elements */}
              <div className="absolute -top-10 -right-10 w-24 h-24 sm:w-32 sm:h-32 bg-[#357BEB] rounded-full blur-3xl opacity-30" data-id="element-7136"></div>
              <div className="absolute -bottom-10 -left-10 w-24 h-24 sm:w-32 sm:h-32 bg-[#21A366] rounded-full blur-3xl opacity-30" data-id="element-7137"></div>
            </motion.div>
          </div>
        </div>

        {/* Decorative wave */}
        <div className="absolute bottom-0 left-0 right-0 pointer-events-none" data-id="element-7138">
          <svg viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-auto" data-id="element-7139"></svg>
        </div>
      </div>

      {/* Features Section - MOBILE OPTIMIZED */}
      <section className="py-12 sm:py-16 md:py-20 bg-gradient-to-br from-gray-50 to-white" data-id="element-7140">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-7141">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="text-center mb-12 sm:mb-16" data-id="element-7142">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#132C53] mb-3 sm:mb-4 px-4" data-id="element-7143">
              De ce să alegi Cautlocuință.ro
            </h2>
            <p className="text-base sm:text-lg md:text-xl text-gray-600 max-w-2xl mx-auto px-4" data-id="element-7144">
              Oferim tot ce ai nevoie pentru a reuși în imobiliare
            </p>
          </motion.div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6" data-id="element-7145">
            {features.map((feature, index) => <motion.div key={feature.title} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="group relative" data-id="element-7146">
                <div className="bg-white rounded-xl sm:rounded-2xl p-5 sm:p-6 shadow-md hover:shadow-2xl transition-all duration-300 border-2 border-transparent hover:border-[#357BEB] h-full" data-id="element-7147">
                  <motion.div whileHover={{
                scale: 1.1,
                rotate: 5
              }} className={`inline-flex items-center justify-center w-12 h-12 sm:w-14 sm:h-14 rounded-xl bg-gradient-to-br ${feature.color} mb-3 sm:mb-4 shadow-lg`} data-id="element-7148">
                    <feature.icon className="w-6 h-6 sm:w-7 sm:h-7 text-white" data-id="element-7149" />
                  </motion.div>
                  <h3 className="text-lg sm:text-xl font-bold text-[#132C53] mb-2" data-id="element-7150">
                    {feature.title}
                  </h3>
                  <p className="text-gray-600 text-sm leading-relaxed" data-id="element-7151">
                    {feature.description}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Vision Section - MOBILE OPTIMIZED */}
      <section className="py-12 sm:py-16 md:py-20 bg-white" data-id="element-7152">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-7153">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 lg:gap-16 items-center" data-id="element-7154">
            {/* Left - Image - MOBILE OPTIMIZED */}
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} className="relative order-2 lg:order-1" data-id="element-7155">
              <div className="absolute inset-0 bg-gradient-to-br from-[#357BEB] to-[#21A366] rounded-2xl sm:rounded-3xl transform rotate-3 opacity-20" data-id="element-7156" />
              <img src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80" alt="Echipa CautLocuinta.ro" className="relative rounded-2xl sm:rounded-3xl shadow-2xl w-full object-cover h-[300px] sm:h-[400px] md:h-[500px]" data-id="element-7157" />

              {/* Floating badge - MOBILE OPTIMIZED */}
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.4
            }} className="absolute bottom-4 left-4 right-4 sm:bottom-8 sm:left-8 sm:right-8 bg-white/95 backdrop-blur-md p-4 sm:p-6 rounded-xl sm:rounded-2xl shadow-2xl border-2 border-white/50" data-id="element-7158">
                <div className="flex items-center justify-between gap-3" data-id="element-7159">
                  <div className="flex-1 min-w-0" data-id="element-7160">
                    <p className="font-bold text-[#132C53] text-sm sm:text-base md:text-lg mb-1 truncate" data-id="element-7161">
                      Alătură-te echipei de succes
                    </p>
                    <p className="text-xs sm:text-sm text-gray-600" data-id="element-7162">
                      50+ agenți activi în ecosistem
                    </p>
                  </div>
                  <CheckCircleIcon className="w-8 h-8 sm:w-10 sm:h-10 text-[#21A366] flex-shrink-0" data-id="element-7163" />
                </div>
              </motion.div>
            </motion.div>

            {/* Right - Content - MOBILE OPTIMIZED */}
            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} className="order-1 lg:order-2" data-id="element-7164">
              <div className="inline-flex items-center space-x-2 bg-gradient-to-r from-[#357BEB] to-[#21A366] text-white px-3 py-1.5 sm:px-4 sm:py-2 rounded-full mb-4 sm:mb-6" data-id="element-7165">
                <SparklesIcon className="w-3 h-3 sm:w-4 sm:h-4" data-id="element-7166" />
                <span className="text-xs sm:text-sm font-semibold" data-id="element-7167">
                  Viziunea noastră
                </span>
              </div>

              <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#132C53] mb-4 sm:mb-6" data-id="element-7168">
                Mai mult decât o agenție imobiliară
              </h2>

              <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-4 sm:mb-6" data-id="element-7169">
                La Cautlocuința.ro, am construit un{' '}
                <span className="font-bold text-[#357BEB]" data-id="element-7170">
                  ecosistem complet
                </span>{' '}
                care transformă agenți începători în consultanți profesioniști.
              </p>

              <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-6 sm:mb-8" data-id="element-7171">
                Prin combinația unică de{' '}
                <span className="font-bold" data-id="element-7172">training structurat</span>,{' '}
                <span className="font-bold" data-id="element-7173">suport individual 24/7</span> și{' '}
                <span className="font-bold" data-id="element-7174">tehnologie avansată</span>, oferim
                fiecărui membru al echipei instrumentele necesare pentru a reuși
                într-o industrie competitivă.
              </p>

              <div className="space-y-3 sm:space-y-4" data-id="element-7175">
                {['Training complet de la zero la expert', 'Suport individual 1-la-1 permanent', 'Platformă digitală cu AI și automatizări', 'Leaduri garantate zilnic'].map((item, idx) => <motion.div key={idx} initial={{
                opacity: 0,
                x: -20
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: idx * 0.1
              }} className="flex items-center space-x-3" data-id="element-7176">
                    <div className="w-5 h-5 sm:w-6 sm:h-6 rounded-full bg-gradient-to-br from-[#21A366] to-[#1a8555] flex items-center justify-center flex-shrink-0" data-id="element-7177">
                      <CheckCircleIcon className="w-3 h-3 sm:w-4 sm:h-4 text-white" data-id="element-7178" />
                    </div>
                    <span className="text-sm sm:text-base text-gray-700 font-medium" data-id="element-7179">
                      {item}
                    </span>
                  </motion.div>)}
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Values Section - MOBILE OPTIMIZED */}
      <section className="py-12 sm:py-16 md:py-20 bg-gradient-to-br from-gray-50 to-blue-50" data-id="element-7180">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-7181">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-12 sm:mb-16" data-id="element-7182">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#132C53] mb-3 sm:mb-4 px-4" data-id="element-7183">
              Valorile noastre fundamentale
            </h2>
            <p className="text-base sm:text-lg md:text-xl text-gray-600 max-w-2xl mx-auto px-4" data-id="element-7184">
              Principiile care ne ghidează în tot ce facem
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8" data-id="element-7185">
            {values.map((value, index) => <motion.div key={value.title} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="group" data-id="element-7186">
                <div className="bg-white rounded-xl sm:rounded-2xl p-6 sm:p-8 shadow-md hover:shadow-2xl transition-all duration-300 border-2 border-transparent hover:border-[#357BEB] h-full" data-id="element-7187">
                  <motion.div whileHover={{
                scale: 1.1,
                rotate: 5
              }} className={`inline-flex items-center justify-center w-14 h-14 sm:w-16 sm:h-16 rounded-xl sm:rounded-2xl bg-gradient-to-br ${value.color} mb-4 sm:mb-6 shadow-lg`} data-id="element-7188">
                    <value.icon className="w-7 h-7 sm:w-8 sm:h-8 text-white" data-id="element-7189" />
                  </motion.div>
                  <h3 className="text-xl sm:text-2xl font-bold text-[#132C53] mb-3 sm:mb-4" data-id="element-7190">
                    {value.title}
                  </h3>
                  <p className="text-sm sm:text-base text-gray-600 leading-relaxed" data-id="element-7191">
                    {value.description}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Stats Section - MOBILE OPTIMIZED */}
      <section className="py-12 sm:py-16 md:py-20 bg-gradient-to-br from-[#132C53] to-[#1e4278] relative overflow-hidden" data-id="element-7192">
        <div className="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]" data-id="element-7193"></div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-7194">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-12 sm:mb-16" data-id="element-7195">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-3 sm:mb-4 px-4" data-id="element-7196">
              Rezultate concrete și măsurabile
            </h2>
            <p className="text-base sm:text-lg md:text-xl text-gray-300 max-w-2xl mx-auto px-4" data-id="element-7197">
              Cifrele care demonstrează succesul ecosistemului nostru
            </p>
          </motion.div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6" data-id="element-7198">
            {stats.map((stat, index) => <motion.div key={stat.label} initial={{
            opacity: 0,
            scale: 0.8
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="group" data-id="element-7199">
                <div className="bg-white/5 backdrop-blur-sm rounded-xl sm:rounded-2xl p-4 sm:p-6 border border-white/10 hover:bg-white/10 transition-all duration-300" data-id="element-7200">
                  <motion.div whileHover={{
                scale: 1.1,
                rotate: 5
              }} className={`inline-flex items-center justify-center w-10 h-10 sm:w-12 sm:h-12 rounded-lg sm:rounded-xl bg-gradient-to-br ${stat.color} mb-3 sm:mb-4 shadow-lg`} data-id="element-7201">
                    <stat.icon className="w-5 h-5 sm:w-6 sm:h-6 text-white" data-id="element-7202" />
                  </motion.div>
                  <div className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-1 sm:mb-2" data-id="element-7203">
                    {stat.number}
                    {stat.suffix}
                  </div>
                  <div className="text-gray-300 text-xs sm:text-sm md:text-base" data-id="element-7204">
                    {stat.label}
                  </div>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Benefits Section - MOBILE OPTIMIZED */}
      <section className="py-12 sm:py-16 md:py-20 bg-white" data-id="element-7205">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-7206">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-12 sm:mb-16" data-id="element-7207">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#132C53] mb-3 sm:mb-4 px-4" data-id="element-7208">
              Beneficiile ecosistemului CLC
            </h2>
            <p className="text-base sm:text-lg md:text-xl text-gray-600 max-w-2xl mx-auto px-4" data-id="element-7209">
              Tot ce primești când devii parte din echipa noastră
            </p>
          </motion.div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6" data-id="element-7210">
            {benefits.map((benefit, index) => <motion.div key={benefit.title} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="group" data-id="element-7211">
                <div className="bg-gradient-to-br from-gray-50 to-white rounded-xl sm:rounded-2xl p-5 sm:p-6 shadow-md hover:shadow-xl transition-all duration-300 border-2 border-gray-100 hover:border-[#357BEB] h-full" data-id="element-7212">
                  <motion.div whileHover={{
                scale: 1.1,
                rotate: 5
              }} className={`w-10 h-10 sm:w-12 sm:h-12 rounded-lg sm:rounded-xl bg-gradient-to-br ${benefit.color} flex items-center justify-center mb-3 sm:mb-4 shadow-lg`} data-id="element-7213">
                    <benefit.icon className="w-5 h-5 sm:w-6 sm:h-6 text-white" data-id="element-7214" />
                  </motion.div>
                  <h3 className="text-base sm:text-lg font-bold text-[#132C53] mb-2" data-id="element-7215">
                    {benefit.title}
                  </h3>
                  <p className="text-gray-600 text-sm leading-relaxed" data-id="element-7216">
                    {benefit.description}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Final CTA Section - MOBILE OPTIMIZED */}
      <section className="py-12 sm:py-16 md:py-20 bg-gradient-to-br from-[#132C53] to-[#1e4278] relative overflow-hidden" data-id="element-7217">
        <div className="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]" data-id="element-7218"></div>

        <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-7219">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-7220">
            <div className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-4 py-2 sm:px-6 sm:py-3 rounded-full mb-6 sm:mb-8 border border-white/20" data-id="element-7221">
              <RocketIcon className="w-4 h-4 sm:w-5 sm:h-5 text-white" data-id="element-7222" />
              <span className="text-sm sm:text-base text-white font-semibold" data-id="element-7223">
                Începe astăzi călătoria ta
              </span>
            </div>

            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4 sm:mb-6 px-4 leading-tight" data-id="element-7224">
              Gata să devii parte din ecosistemul CLC?
            </h2>

            <p className="text-base sm:text-lg md:text-xl text-gray-300 mb-8 sm:mb-10 max-w-2xl mx-auto leading-relaxed px-4" data-id="element-7225">
              Parcurge cursul complet și descoperă cum poți deveni un consultant
              imobiliar de succes cu suport complet și rezultate garantate
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center space-y-3 sm:space-y-0 sm:space-x-4 px-4" data-id="element-7226">
              <Link to="/auth/register" className="inline-flex items-center space-x-2 bg-gradient-to-r from-[#357BEB] to-[#21A366] text-white px-8 py-4 sm:px-10 sm:py-5 rounded-xl sm:rounded-2xl font-bold text-base sm:text-lg hover:shadow-2xl hover:scale-105 transition-all duration-300 group w-full sm:w-auto justify-center" data-id="element-7227">
                <span data-id="element-7228">Devino Agent Acum</span>
                <ArrowRightIcon className="w-5 h-5 sm:w-6 sm:h-6 group-hover:translate-x-1 transition-transform" data-id="element-7229" />
              </Link>

              <Link to="/cursuri" className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm text-white px-8 py-4 sm:px-10 sm:py-5 rounded-xl sm:rounded-2xl font-bold text-base sm:text-lg hover:bg-white/20 transition-all duration-300 border-2 border-white/20 w-full sm:w-auto justify-center" data-id="element-7230">
                <BookOpenIcon className="w-5 h-5 sm:w-6 sm:h-6" data-id="element-7231" />
                <span data-id="element-7232">Vezi Cursurile</span>
              </Link>
            </div>

            <p className="mt-6 sm:mt-8 text-xs sm:text-sm text-gray-400 px-4" data-id="element-7233">
              ✓ Fără experiență necesară • ✓ Training complet inclus • ✓ Suport
              24/7 • ✓ Start în 60 secunde
            </p>
          </motion.div>
        </div>
      </section>
    </div>;
}